// src/packages/dhipaya/motor/dhipaya_truck_2p3p_2025/DhipayaTruckDetails.jsx
import React from "react";
import "./dhipaya_truck.css";

/**
 * ตารางเบี้ยคัดตามเอกสาร 01.04.2025 (2+ / 3+) — Dhipaya Trucks
 * โครงสร้าง Zero-index: ไม่มีตัวแปรชื่อ index ใน JSX
 * อ้างอิงตารางเบี้ยและความคุ้มครองจากเอกสารที่อัปโหลดไว้
 */

const money = (n) => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

// ===== ตารางเบี้ย (ทุน 100k–500k) =====
const rows = {
  // 320 รถบรรทุก (Pickup/Truck) — มี/ไม่มีอุปกรณ์, 4–12t / >12t
  "320-plain-4to12": [
    { sum: 100000, p2p: 17500, p3p: 16500 },
    { sum: 200000, p2p: 18500, p3p: 17500 },
    { sum: 300000, p2p: 19500, p3p: 18500 },
    { sum: 400000, p2p: 20500, p3p: 19500 },
    { sum: 500000, p2p: 21500, p3p: 20500 },
  ],
  "320-equip-4to12": [
    { sum: 100000, p2p: 19500, p3p: 18500 },
    { sum: 200000, p2p: 21500, p3p: 20500 },
    { sum: 300000, p2p: 23500, p3p: 22500 },
    { sum: 400000, p2p: 25500, p3p: 24500 },
    { sum: 500000, p2p: 27500, p3p: 26500 },
  ],
  "320-plain-gt12": [
    { sum: 100000, p2p: 19100, p3p: 18200 },
    { sum: 200000, p2p: 20400, p3p: 19300 },
    { sum: 300000, p2p: 21500, p3p: 20400 },
    { sum: 400000, p2p: 22599, p3p: 21500 },
    { sum: 500000, p2p: 23699, p3p: 22599 },
  ],
  "320-equip-gt12": [
    { sum: 100000, p2p: 21500, p3p: 20400 },
    { sum: 200000, p2p: 23699, p3p: 22599 },
    { sum: 300000, p2p: 25900, p3p: 24800 },
    { sum: 400000, p2p: 28100, p3p: 27000 },
    { sum: 500000, p2p: 30300, p3p: 29200 },
  ],

  // 420 รถหัวลาก (Tractor Head) — ไม่มี/มีอุปกรณ์
  "420-plain": [
    { sum: 100000, p2p: 31100, p3p: 30000 },
    { sum: 200000, p2p: 33400, p3p: 31500 },
    { sum: 300000, p2p: 35400, p3p: 32200 },
    { sum: 400000, p2p: 37400, p3p: 32800 },
    { sum: 500000, p2p: 39400, p3p: 33299 },
  ],
  "420-equip": [
    { sum: 100000, p2p: 34399, p3p: 33100 },
    { sum: 200000, p2p: 36799, p3p: 35300 },
    { sum: 300000, p2p: 39000, p3p: 36600 },
    { sum: 400000, p2p: 41200, p3p: 37100 },
    { sum: 500000, p2p: 43400, p3p: 37700 },
  ],

  // 520 รถหางพ่วง (Trailer) — ไม่มี/มีอุปกรณ์
  "520-plain": [
    { sum: 100000, p2p: 13900, p3p: 13400 },
    { sum: 200000, p2p: 15500, p3p: 13800 },
    { sum: 300000, p2p: 17000, p3p: 14299 },
    { sum: 400000, p2p: 18400, p3p: 14500 },
    { sum: 500000, p2p: 19700, p3p: 14700 },
  ],
  "520-equip": [
    { sum: 100000, p2p: 15700, p3p: 15600 },
    { sum: 200000, p2p: 17400, p3p: 16000 },
    { sum: 300000, p2p: 19100, p3p: 16500 },
    { sum: 400000, p2p: 20600, p3p: 16699 },
    { sum: 500000, p2p: 22100, p3p: 16900 },
  ],
};

// เมตาไว้เรนเดอร์หัวตาราง/คำอธิบาย
const tableDefs = [
  { key: "320-plain-4to12", title: "320 ไม่มีอุปกรณ์ • 4–12 ตัน" },
  { key: "320-equip-4to12", title: "320 มีอุปกรณ์ • 4–12 ตัน" },
  { key: "320-plain-gt12",  title: "320 ไม่มีอุปกรณ์ • >12 ตัน" },
  { key: "320-equip-gt12",  title: "320 มีอุปกรณ์ • >12 ตัน" },
  { key: "420-plain",       title: "420 หัวลาก • ไม่มีอุปกรณ์" },
  { key: "420-equip",       title: "420 หัวลาก • มีอุปกรณ์" },
  { key: "520-plain",       title: "520 หางพ่วง • ไม่มีอุปกรณ์" },
  { key: "520-equip",       title: "520 หางพ่วง • มีอุปกรณ์" },
];

const highlights = [
  "ทุนให้เลือก 100,000 – 500,000 บาท (ตามแผน)",
  "2+ ครอบคลุมความเสียหายต่อรถตนเอง (ชนกับยานพาหนะทางบก) + ทรัพย์สิน/บุคคลภายนอก",
  "3+ ครอบคลุมเมื่อชนกับยานพาหนะทางบก + ทรัพย์สิน/บุคคลภายนอก",
];

const coverageNotes = [
  "ความเสียหายรถตนเอง: ตามทุนประกัน (เฉพาะกรณีชนกับยานพาหนะทางบก)",
  "ความรับผิดต่อบุคคลภายนอก: 500,000 บาท/คน; 10,000,000 บาท/ครั้ง",
  "ทรัพย์สินบุคคลภายนอก: 1,000,000 บาท/ครั้ง",
  "เอกสารแนบท้าย (เฉพาะ 2+): ร.ย.01/02/03 จำนวนที่นั่งสูงสุด 3 คน",
];

const remarks = [
  "รับประกันอายุรถไม่เกิน 20 ปี",
  "อุปกรณ์เพิ่มพิเศษ เช่น ดั๊มพ์, เครื่องไฮดรอลิก, ตู้เย็น (ยกเว้นความเสียหายจากอุปกรณ์ทำความเย็น)",
  "อัตราเบี้ยรวมภาษีอากรแล้ว (ไม่รวม พ.ร.บ.)",
  "บริษัทขอสงวนสิทธิ์ตรวจสภาพรถก่อนรับประกัน และพิจารณาเป็นกรณีสำหรับงานเสี่ยงพิเศษ",
];

export default function DhipayaTruckDetails({ onQuote }) {
  return (
    <div className="pkg-detail dhipaya-truck">
      <h2>Dhipaya Truck 2+ / 3+ — โค้ด 320 / 420 / 520</h2>
      <p className="pkg-note">
        ตารางเบี้ยมีผลใช้ 01 เม.ย. 2025 — จัดรูปสำหรับขาย: แยกตามโค้ดรถ, อุปกรณ์, น้ำหนัก, และทุนเอาประกัน
        {/* อ้างอิงเอกสารบริษัท */}
      </p>

      <h3 className="pkg-section">จุดขายสำคัญ</h3>
      <ul className="pkg-bullets">
        {highlights.map((t) => <li key={`hi-${t}`}>{t}</li>)}
      </ul>

      <h3 className="pkg-section">สรุปความคุ้มครองหลัก</h3>
      <ul className="pkg-bullets">
        {coverageNotes.map((t) => <li key={`cov-${t}`}>{t}</li>)}
      </ul>

      {tableDefs.map((tbl) => (
        <div className="pkg-table-wrap" key={`tbl-${tbl.key}`}>
          <h4 className="pkg-subtitle">{tbl.title}</h4>
          <table className="pkg-table">
            <thead>
              <tr>
                <th>ทุน (บาท)</th>
                <th>เบี้ย 2+ (รวมภาษี)</th>
                <th>เบี้ย 3+ (รวมภาษี)</th>
              </tr>
            </thead>
            <tbody>
              {(rows[tbl.key] || []).map((r) => (
                <tr key={`${tbl.key}-${r.sum}`}>
                  <td>{money(r.sum)}</td>
                  <td>{money(r.p2p)}</td>
                  <td>{money(r.p3p)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}

      <h3 className="pkg-section">หมายเหตุ / เงื่อนไขสำคัญ</h3>
      <ul className="pkg-bullets">
        {remarks.map((t) => <li key={`rmk-${t}`}>{t}</li>)}
      </ul>

      <div className="pkg-foot">
        <p className="pkg-note">* โปรดอ่านเงื่อนไขกรมธรรม์ฉบับเต็มก่อนตัดสินใจซื้อ</p>
        <button className="pkg-quote-btn" onClick={onQuote} aria-label="ขอใบเสนอราคา Dhipaya Truck">
          ขอใบเสนอราคา
        </button>
      </div>
    </div>
  );
}
